import { lazy, Suspense } from "react";
import Loader from '../customs/spinner/spinner';

const Main = lazy(() => import('../components/myDrivers/main'));

const myDrivers = () => {
    return (
        <Suspense fallback={<Loader color="#E57D1E"/>}>
            <Main/>
        </Suspense>
    )
}

export default myDrivers;